import {
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
} from "@material-ui/core";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import TuneIcon from "@mui/icons-material/Tune";
import { getColorByEnv } from "utils/get-colors-by-env";
import { IsMobile } from "utils/is-mobile";
import themeColorsDesingSystem from "assets/theme/ds-colors";
import useMarketingStyles from "../styles";

const { gray, text } = themeColorsDesingSystem;

export function MarketingPageHeader() {
  return (
    <Container
      maxWidth={false}
      style={{ backgroundColor: getColorByEnv(), paddingBottom: "5rem" }}
    >
      <Typography
        variant="h2"
        component="h6"
        style={{ color: "#fff", fontWeight: 700 }}
      >
        Materiais de Marketing
      </Typography>
      <Typography
        variant="body2"
        style={{ color: "rgba(255,255,255,0.88)", marginTop: 6 }}
      >
        Encontre campanhas, materiais e conteúdos para sua loja.
      </Typography>
    </Container>
  );
}

export function MarketingSearchBar({ search, onSearchChange, onOpenFilters }) {
  const classes = useMarketingStyles();
  const isMobile = IsMobile();

  return (
    <Card className={classes.headerCard} elevation={0}>
      <CardContent style={{ padding: isMobile ? 16 : "20px 24px" }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={10}>
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Buscar materiais..."
              value={search}
              onChange={(e) => onSearchChange(e.target.value)}
              className={classes.searchField}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon style={{ color: gray.main }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                "& .MuiInputBase-input": {
                  color: text.primary,
                  fontFamily: "Open Sans,sans-serif",
                },
              }}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <Button
              fullWidth={isMobile}
              variant="outlined"
              color="primary"
              startIcon={<TuneIcon />}
              onClick={onOpenFilters}
              className={classes.filterButton}
              style={{
                float: isMobile ? "none" : "right",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              Filtros
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
